angular
  .module('common.directives')
  .directive('healthReportsAlarms', function () {
    return {
      templateUrl:
        './templates/health-reports/health-reports-alarms.view.html?t=' +
        webpackHash,
      link: function ($scope, $element) {},
      controller: 'healthReportsAlarmsController'
    }
  })
